import { render, staticRenderFns } from "./CloudBackupRestore.vue?vue&type=template&id=4afad4e2&scoped=true"
import script from "./CloudBackupRestore.vue?vue&type=script&lang=js"
export * from "./CloudBackupRestore.vue?vue&type=script&lang=js"
import style0 from "./CloudBackupRestore.vue?vue&type=style&index=0&id=4afad4e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afad4e2",
  null
  
)

export default component.exports